<div class="tw-flex tw-justify-between">
    <h1
        mat-dialog-title
        translate>
        OUTGOING-GOODS.COLUMN-FILTERS-DIALOG.TITLE
    </h1>

    <button
        mat-icon-button
        mat-dialog-close>
        <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
    </button>
</div>

@for (col of columnData(); track col.name) {
    <div>
        @if (!isTours?.valueOf()) {
            <mat-checkbox
                [(ngModel)]="col.shouldDisplay"
                [disabled]="!!col.disabled">
                @if (col.name !== '_key' || !keyLabel) {
                    <span>{{
                        'OUTGOING-GOODS.COLUMN-FILTERS.' + col.name | translate
                    }}</span>
                } @else {
                    {{ keyLabel || '' | translate }}
                }
            </mat-checkbox>
        }

        @if (isTours?.valueOf()) {
            <mat-checkbox
                [(ngModel)]="col.shouldDisplay"
                [disabled]="!!col.disabled">
                @if (col.name !== '_key' || !keyLabel) {
                    <span>{{
                        'SPEDITEUR.TABLE.COLUMN-FILTERS.' + col.name | translate
                    }}</span>
                } @else {
                    {{ keyLabel || '' | translate }}
                }
            </mat-checkbox>
        }
    </div>
}

@if (!amountOfChecked) {
    <div
        class="tw-mt-3 tw-text-red-500"
        translate>
        OUTGOING-GOODS.COLUMN-FILTERS-DIALOG.SELECT-ONE-ROW
    </div>
}

<div
    mat-dialog-actions
    align="end">
    <button
        mat-button
        mat-dialog-close>
        {{ 'GENERAL.CANCEL' | translate }}
    </button>
    <button
        mat-button
        (click)="reset()">
        {{ 'GENERAL.RESET' | translate }}
    </button>
    <button
        mat-raised-button
        color="primary"
        (click)="closeDialog()"
        [disabled]="!amountOfChecked">
        {{ 'GENERAL.CONFIRM' | translate }}
    </button>
</div>
